module.exports = __webpack_public_path__ + "static/media/loader1.df34d37a.gif";